<template>
    <img :src="avatarUrl" :alt="alt" v-if="avatar">
</template>
<script>
    export default {
        name: 'avatar',

        props: ['avatar', 'name'],

        data() {
            return {
                alt: this.name + ' avatar'
            }
        },

        computed: {
            avatarUrl() {
                return this.url(this.avatar)
            }
        },

        methods: {
            url(avatar) {
                let avatarPath = process.env.AVATARS[process.env.DEFAULT_AVATAR]

                if (_.has(process.env.AVATARS, avatar)) {
                    avatarPath = process.env.AVATARS[avatar]
                }

                return '/static/avatars/' + avatarPath + '.png'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Avatar.vue